export class MonthlyConfig {
    'daysOfMonth';
    'timeOfDay';
    'startWindowMinutes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "daysOfMonth",
            "baseName": "daysOfMonth",
            "type": "Set<number>",
            "format": ""
        },
        {
            "name": "timeOfDay",
            "baseName": "timeOfDay",
            "type": "TimeOfDay",
            "format": ""
        },
        {
            "name": "startWindowMinutes",
            "baseName": "startWindowMinutes",
            "type": "number",
            "format": "long"
        }
    ];
    static getAttributeTypeMap() {
        return MonthlyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
